module["exports"] = [
  "#{street_name} no #{building_number}"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/street_address.js
// module id = 1207
// module chunks = 1